export const SIGNATURE_PROMPT_TEXT = `Good morning, everyone.
Today I'd like to share a few thoughts on the importance of clear communication in our daily lives.
Whether we're at work, at home, or with friends, the ability to convey our ideas effectively is essential.
Clear communication helps to avoid misunderstandings, build strong relationships, and ensures that everyone is on the same page.
It involves not only the words we choose, but also our tone of voice, body language, and listening skills.
By practicing, active listening, and being mindful of our speech, we can become better communicators and foster a more harmonious environment.
Thank you for listening and have a great day ahead.`;

